import Vue from "vue";
import Router from "vue-router";
const Home = () => import("@/page/home");
const Product = () => import("@/page/product");
const Member = () => import("@/page/member");
const ProductDetails = () => import("@/page/productDetails");
const CreateOrder = () => import("@/page/createOrder");
const openMember = () => import("@/page/openMember");
const MemberPaySuccess = () => import("@/page/memberPaySuccess");
const PayOrder = () => import("@/page/payOrder");
const PaySuccess = () => import("@/page/paySuccess");
const Agreement = () => import("@/page/agreement");
const About = () => import("@/page/about");
const Join = () => import("@/page/join");
const Contact = () => import("@/page/contact");
const News = () => import("@/page/news");
const NewsDetails = () => import("@/page/newsDetails");
const Consult = () => import("@/page/consult");
const ConsultDetails = () => import("@/page/consultDetails");

const Personal = () => import("@/page/personal");
const Record = () => import("@/page/record");
const ChangeRecord = () => import("@/page/changeRecord");
const Account = () => import("@/page/account");
const ChangePassword = () => import("@/page/changePassword");
const ChangePhone = () => import("@/page/changePhone");
const ForgetPassword = () => import("@/page/forgetPassword");
const Login = () => import("@/page/login");
const Register = () => import("@/page/register");
const RegisterAgreement = () => import("@/page/registerAgreement");
const Order = () => import("@/page/order");
const Recharge = () => import("@/page/recharge");
const Result = () => import("@/page/result");
const Request = () => import("@/page/request");
const MyProduct = () => import("@/page/myProduct");
const ProductUsage = () => import("@/page/productUsage");
const MyOrder = () => import("@/page/myOrder");
const OrderDetail = () => import("@/page/orderDetail");
const SetPassword = () => import("@/page/setPassword");
const WxLogin = () => import("@/page/wxLogin");
const Material = () => import("@/page/material");
const Coupon = () => import("@/page/coupon");

const Certification = () => import("@/page/certification/index");
const CertificationAuthenticated = () =>
  import("@/page/certification/authenticated");
const CertificationCompany = () => import("@/page/certification/company");
const CertificationPersonal = () => import("@/page/certification/personal");
const CertificationRecord = () => import("@/page/certification/record");

const Activity618 = () => import("@/page/activity618");
const ActivityInvite = () => import("@/page/activityInvite");

const Entrance = () => import("@/page/experience/entrance");
const FaceCheck = () => import("@/page/experience/faceCheck");
const IdCardCheck = () => import("@/page/experience/idCardCheck");
const IdCardOcr = () => import("@/page/experience/idCardOcr");
const LiveCheckProcess = () => import("@/page/experience/liveCheck/process");
const LiveCheckResult = () => import("@/page/experience/liveCheck/result");
const RealPersonProcess = () => import("@/page/experience/realPerson/process");
const RealPersonResult = () => import("@/page/experience/realPerson/result");
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "数脉API"
      }
    },
    {
      path: "/home",
      // 重定向
      redirect: "/",
      name: "home",
      component: Home,
      meta: {
        title: "数脉API"
      }
    },
    {
      path: "/product",
      name: "product",
      component: Product,
      meta: {
        title: "产品"
      }
    },
    {
      path: "/product/:type",
      name: "product",
      component: Product,
      meta: {
        title: "产品"
      }
    },
    {
      path: "/product/details/:id",
      name: "ProductDetails",
      component: ProductDetails,
      meta: {
        title: "产品详情"
      }
    },
    {
      path: "/createOrder",
      name: "createOrder",
      component: CreateOrder,
      meta: {
        title: "确认购买"
      }
    },
    {
      path: "/member",
      name: "member",
      component: Member,
      meta: {
        title: "会员中心"
      }
    },
    {
      path: "/memberPaySuccess",
      name: "memberPaySuccess",
      component: MemberPaySuccess,
      meta: {
        title: "会员开通成功"
      }
    },
    {
      path: "/openMember",
      name: "openMember",
      component: openMember,
      meta: {
        title: "开通会员产品"
      }
    },
    {
      path: "/payOrder",
      name: "payOrder",
      component: PayOrder,
      meta: {
        title: "立即支付"
      }
    },
    {
      path: "/paySuccess",
      name: "paySuccess",
      component: PaySuccess,
      meta: {
        title: "支付成功"
      }
    },
    {
      path: "/agreement",
      name: "agreement",
      component: Agreement,
      meta: {
        title: "服务协议"
      }
    },
    {
      path: "/about",
      name: "about",
      component: About,
      meta: {
        title: "关于我们"
      }
    },
    {
      path: "/join",
      name: "join",
      component: Join,
      meta: {
        title: "加入我们"
      }
    },
    {
      path: "/personal",
      name: "personal",
      component: Personal,
      meta: {
        title: "我的数聚"
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      meta: {
        title: "联系我们"
      }
    },
    {
      path: "/news/:type",
      name: "news",
      component: News,
      meta: {
        title: "动态"
      }
    },
    {
      path: "/news/details/:id",
      name: "newsDetails",
      component: NewsDetails,
      meta: {
        title: "动态详情"
      }
    },
    {
      path: "/consult/:id",
      name: "consult",
      component: Consult,
      meta: {
        title: "产品资讯"
      }
    },
    {
      path: "/consult/details/:id",
      name: "consultDetails",
      component: ConsultDetails,
      meta: {
        title: "产品资讯详情"
      }
    },
    {
      path: "/record",
      name: "record",
      component: Record,
      meta: {
        title: "充值记录",
        requireAuth: true
      }
    },
    {
      path: "/changeRecord",
      name: "changeRecord",
      component: ChangeRecord,
      meta: {
        title: "充值数据变更",
        requireAuth: true
      }
    },
    {
      path: "/record",
      name: "record",
      component: Record,
      meta: {
        title: "充值记录",
        requireAuth: true
      }
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      meta: {
        title: "账户资料",
        requireAuth: true
      }
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: ChangePassword,
      meta: {
        title: "修改密码",
        requireAuth: true
      }
    },
    {
      path: "/changePhone",
      name: "changePhone",
      component: ChangePhone,
      meta: {
        title: "更换手机",
        requireAuth: true
      }
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      component: ForgetPassword,
      meta: {
        title: "忘记密码",
        requireAuth: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录",
        requireAuth: false
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        title: "注册",
        requireAuth: false
      }
    },
    {
      path: "/material",
      name: "material",
      component: Material,
      meta: {
        title: "完善资料",
        requireAuth: false
      }
    },
    {
      path: "/certification",
      name: "certification",
      component: Certification,
      meta: {
        title: "实名认证",
        requireAuth: false
      }
    },
    {
      path: "/certification/authenticated",
      name: "certificationAuthenticated",
      component: CertificationAuthenticated,
      meta: {
        title: "实名认证结果",
        requireAuth: false
      }
    },
    {
      path: "/certification/company",
      name: "certificationCompany",
      component: CertificationCompany,
      meta: {
        title: "企业认证",
        requireAuth: false
      }
    },
    {
      path: "/certification/personal",
      name: "certificationPersonal",
      component: CertificationPersonal,
      meta: {
        title: "个人认证",
        requireAuth: false
      }
    },
    {
      path: "/certification/record",
      name: "certificationRecord",
      component: CertificationRecord,
      meta: {
        title: "实名认证记录",
        requireAuth: false
      }
    },
    {
      path: "/registerAgreement",
      name: "registerAgreement",
      component: RegisterAgreement,
      meta: {
        title: "数脉API用户服务协议",
        requireAuth: false
      }
    },
    {
      path: "/order",
      name: "order",
      component: Order,
      meta: {
        title: "支付订单",
        requireAuth: true
      }
    },
    {
      path: "/recharge",
      name: "recharge",
      component: Recharge,
      meta: {
        title: "充值",
        requireAuth: true
      }
    },
    {
      path: "/request",
      name: "request",
      component: Request,
      meta: {
        title: "调用记录",
        requireAuth: true
      }
    },
    {
      path: "/myProduct",
      name: "myProduct",
      component: MyProduct,
      meta: {
        title: "我的产品",
        requireAuth: true
      }
    },
    {
      path: "/coupon",
      name: "coupon",
      component: Coupon,
      meta: {
        title: "优惠券",
        requireAuth: true
      }
    },
    {
      path: "/productUsage",
      name: "productUsage",
      component: ProductUsage,
      meta: {
        title: "使用统计",
        requireAuth: true
      }
    },
    {
      path: "/setPassword",
      name: "setPassword",
      component: SetPassword,
      meta: {
        title: "设置密码",
        requireAuth: false
      }
    },
    {
      path: "/wxLogin",
      name: "wxLogin",
      component: WxLogin,
      meta: {
        title: "微信授权登录",
        requireAuth: false
      }
    },
    {
      path: "/result",
      name: "result",
      component: Result,
      meta: {
        title: "充值结果",
        requireAuth: false
      }
    },
    {
      path: "/myOrder",
      name: "myOrder",
      component: MyOrder,
      meta: {
        title: "我的订单",
        requireAuth: false
      }
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      component: OrderDetail,
      meta: {
        title: "订单详情",
        requireAuth: false
      }
    },
    {
      path: "/activity618",
      name: "activity618",
      component: Activity618,
      meta: {
        title: "618狂欢购",
        requireAuth: false
      }
    },
    {
      path: "/activityInvite",
      name: "activityInvite",
      component: ActivityInvite,
      meta: {
        title: "邀新人迎大礼",
        requireAuth: false
      }
    },
    {
      path: "/experience/entrance",
      name: "entrance",
      component: Entrance,
      meta: {
        title: "体验首页"
      }
    },
    {
      path: "/experience/faceCheck",
      name: "faceCheck",
      component: FaceCheck,
      meta: {
        title: "人脸识别"
      }
    },
    {
      path: "/experience/idCardCheck",
      name: "idCardCheck",
      component: IdCardCheck,
      meta: {
        title: "身份证识别"
      }
    },
    {
      path: "/experience/idCardOcr",
      name: "idCardOcr",
      component: IdCardOcr,
      meta: {
        title: "身份证OCR"
      }
    },
    {
      path: "/experience/liveCheckProcess",
      name: "liveCheckProcess",
      component: LiveCheckProcess,
      meta: {
        title: "活体检测"
      }
    },
    {
      path: "/experience/liveCheckResult",
      name: "liveCheckResult",
      component: LiveCheckResult,
      meta: {
        title: "活体检测结果"
      }
    },
    {
      path: "/experience/realPersonProcess",
      name: "realPersonProcess",
      component: RealPersonProcess,
      meta: {
        title: "实人认证"
      }
    },
    {
      path: "/experience/realPersonResult",
      name: "realPersonResult",
      component: RealPersonResult,
      meta: {
        title: "实人认证结果"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js